<template>
  <v-menu v-model="isMenuShown" :close-on-content-click="false" offset="16" z-index="3" location="bottom">
    <template #activator="{ props: menuProps, isActive }">
      <v-btn
        class="filter__btn mx-3 px-3"
        :color="isActive || activated ? 'orange50' : ''"
        min-width="100"
        height="40"
        variant="text"
        v-bind="menuProps"
      >
        <FunnowSvgIcon class="mr-2" max-width="24" image-path="clock.svg" />
        <span class="btn__text wd-text-otempmd">{{ displayText }}</span>
      </v-btn>
    </template>

    <FilterMenuCard
      v-if="isMenuShown"
      :filter-value="selectedTimes"
      :filter-selected="activated"
      :current-filter="currentFilter"
      :total-count="totalCount"
      :key-value="keyValue"
      :is-branch-card-mode="isBranchCardMode"
      :clear-btn="true"
      :menu-width="480"
      filter-key="time"
      content-type="time-picker"
      @confirm="onConfirm"
    />
  </v-menu>
</template>

<script setup lang="ts">
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

const FilterMenuCard = defineAsyncComponent(() => import('@/components/page/categories/filter-menu-card.vue'))

interface Props {
  displayText: string
  activated?: boolean
  selectedTimes?: string[]
  keyValue?: string[]
  currentFilter?: Record<string, unknown>
  totalCount?: number
  isBranchCardMode?: boolean
}

interface Emits {
  (e: 'confirm', filterResponse: Record<string, unknown>): void
}

const props = withDefaults(defineProps<Props>(), {
  activated: false,
  selectedTimes: () => [],
  keyValue: () => ['filter_times'],
  currentFilter: () => ({}),
  totalCount: 0,
  isBranchCardMode: true,
})

const emit = defineEmits<Emits>()

const isMenuShown = ref(false)

function onConfirm(filterResponse: Record<string, unknown>) {
  isMenuShown.value = false
  emit('confirm', filterResponse)
}
</script>
